module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185518.347493b2.jpg";